import { Component, type ErrorInfo, type ReactNode } from 'react';

/**
 * A page that throws while rendering must never leave a blank window. The fallback is plain markup with
 * no dependencies, so it still works if the failure was in shared code.
 */
export class ErrorBoundary extends Component<{ children: ReactNode }, { failed: boolean }> {
  state = { failed: false };

  static getDerivedStateFromError() {
    return { failed: true };
  }

  componentDidCatch(error: Error, info: ErrorInfo) {
    console.error('Athenaeum Library: a page failed to render', error, info.componentStack);
  }

  render() {
    if (!this.state.failed) return this.props.children;
    return (
      <div className="container medium">
        <div className="card card-pad stack" role="alert">
          <h1>Something went wrong showing this page.</h1>
          <p className="muted">Nothing was changed. Reloading usually fixes it.</p>
          <div className="row">
            <button className="btn sm" onClick={() => window.location.reload()}>
              Reload
            </button>{' '}
            <a href="/">Back to the front page</a>
          </div>
        </div>
      </div>
    );
  }
}
